/* ar tour of property using "3 js"
 =>> use box geometry for sphere and for loop to put 
photos inside box instead of outside
then use texture and esh geometry to load pictures

C:\Users\Vidita Shetty\Desktop\FRONTEND PROJECTS\ReactJS-Real-estate-project\frontend\node_modules\three\build\three.js
*/

import React, { useState } from 'react'
import './arTour.css';
import KeyboardDoubleArrowRightRoundedIcon from '@mui/icons-material/KeyboardDoubleArrowRightRounded';
import * as THREE from 'three';
import {OrbitControls} from "three/examples/jsm/controls/OrbitControls";
import Nav from '../Nav/Nav';
import front from './model/MarriottMadisonWest/front.jpg';
import back from './model/MarriottMadisonWest/back.jpg';
import left from './model/MarriottMadisonWest/left.jpg';
import right from './model/MarriottMadisonWest/right.jpg';
import top from './model/MarriottMadisonWest/top.jpg';
import bottom from './model/MarriottMadisonWest/bottom.jpg';

const ArTour = () => {

const scene = new THREE.Scene();
const camera = new THREE.PerspectiveCamera( 5, window.innerWidth / window.innerHeight, 0.1, 1000 );
const renderer = new THREE.WebGLRenderer();
renderer.setPixelRatio((window.devicePixelRatio) ? window.devicePixelRatio : 1);
renderer.autoClear = false;//to remove black background***
renderer.setClearColor = (0x000000, 0.0);
//console.log(renderer);

function ArToutFn(){
    renderer.setSize( window.innerWidth, window.innerHeight );
    document.body.appendChild( renderer.domElement );
    const geometry = new THREE.BoxGeometry( 1, 1, 1 );
    const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
    const cube = new THREE.Mesh( geometry, material );
    //scene.add( cube );

    // Adding orbit controls
    let controls = new OrbitControls(camera, renderer.domElement);controls.minDistance = 0;controls.maxDistance = 40;   
    // loader for loading texture
    let loader = new THREE.TextureLoader();
    // array for holding all texutre
    let textureArray = [];
    // all texture
    let frontTexture = loader.load(front);let backTexture = loader.load(back);let topTexture = loader.load(top);let bottomTexture = loader.load(bottom); let rightTexture = loader.load(left);let leftTexture = loader.load(right);
    textureArray.push(new THREE.MeshBasicMaterial({map: frontTexture}));textureArray.push(new THREE.MeshBasicMaterial({map: backTexture}));textureArray.push(new THREE.MeshBasicMaterial({map: topTexture}));textureArray.push(new THREE.MeshBasicMaterial({map: bottomTexture}));textureArray.push(new THREE.MeshBasicMaterial({map: rightTexture}));textureArray.push(new THREE.MeshBasicMaterial({map: leftTexture}));
    for(let i=0; i<textureArray.length; i++){
        textureArray[i].side = THREE.BackSide;
    }
    // making cube
    const cubeGeometry = new THREE.BoxGeometry(1,1,1);
    const skyBox = new THREE.Mesh(cubeGeometry, textureArray);
    scene.add(skyBox);

    camera.position.z = 5;
   // camera.position.set(0, 0, 25);

    function animate() {
        requestAnimationFrame( animate );
        renderer.render( scene, camera );
    }
    // Resizing window to make responsive
            const windowResize = ()=>{
                camera.aspect = window.innerWidth / window.innerHeight;
                camera.updateProjectionMatrix();
                renderer.setSize(window.innerWidth, window.innerHeight);
        }
    window.addEventListener('resize', windowResize, false);
    animate();
    setEndTourState(false);
}

const[EndTourState,setEndTourState]=useState(true);
function EndTour(){
    window.location.reload();/* FF=ORCE RELOAD PAG ETO REMOVE CANVAS FROM SCREEN */
    setEndTourState(true);
}

  return (
    <div className='ARTourDiv'>
        {EndTourState? <Nav/> :         <button onClick={EndTour} className='arButton'>END TOUR</button>}
        <button onClick={ArToutFn} className='arButton'>{'  '}Start  Tour<KeyboardDoubleArrowRightRoundedIcon/></button>
       {/* <canvas className="web-gl"></canvas>*/}
    </div>
  )
}

export default ArTour